// extracted by mini-css-extract-plugin
export var attachment = "_p5-a";
export var emailContainer = "_p5-4";
export var emailContentPaddedContainer = "_p5-b";
export var emailHeader = "_p5-6";
export var emailIframe = "_p5-3";
export var emailInfoIcon = "_p5-9";
export var emailShortenedSummary = "_p5-e";
export var infoDropdown = "_p5-0";
export var infoRowBoundedContent = "_p5-d";
export var internal = "_p5-5";
export var merchant = "_p5-8";
export var messageInputContainer = "_p5-h";
export var normal = "_p5-7";
export var replyCard = "_p5-f";
export var subtleButton = "_p5-1";
export var subtleButtonIconContainer = "_p5-2";
export var toggleViewRepliesButton = "_p5-c";
export var wrappingText = "_p5-g";